<template>
  <Button
    tag="button"
    theme="contained"
    title="Volver al Inicio"
    @click="returnToTop()"
    rounded
    :class="[isVisible && 'visible']"
  >
    <IconNorth />
  </Button>
</template>
<script>
import IconNorth from "@/components/ui/icons/IconNorth";
import Button from "@/components/ui/atoms/Button";
import { ref } from "@vue/reactivity";
export default {
  components: {
    IconNorth,
    Button
  },
  setup() {
    let isVisible = ref(false);
    const handleScroll = () => {
      isVisible.value = window.scrollY > 100;
    };
    const returnToTop = () => {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    };
    window.addEventListener("scroll", handleScroll);
    return {
      isVisible,
      returnToTop
    };
  }
};
</script>
<style lang="scss" scoped>
@use "@/assets/styles/settings/_variables.scss";
button {
  position: fixed;
  z-index: 1;
  padding: 0;
  width: 3.5rem;
  height: 3.5rem;
  right: variables.$spacing;
  bottom: variables.$spacing;
  visibility: hidden;
  opacity: 0;
  box-shadow: 0px 3px 5px -1px rgb(0 0 0 / 20%),
    0px 6px 10px 0px rgb(0 0 0 / 14%), 0px 1px 18px 0px rgb(0 0 0 / 12%);
  &.visible {
    visibility: visible;
    opacity: 1;
  }
  svg {
    height: 2em;
  }
}
</style>
